import { Component, Input } from '@angular/core';
import { CourseModel } from 'src/app/models/backend.model';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-course-grid',
  templateUrl: './course-grid.component.html',
})
export class CourseGridComponent {
  @Input() courses!: CourseModel[];
  @Input() title = '';
  @Input() showCourseNumber = false;
  @Input() maxColumns = 4;

  backendUrl = environment.backendUrl;

  constructor() { }

}
